<script setup lang="ts">
    import { computed, toRef } from 'vue'

    import type { ReportBuilderViewModel } from '@Reports/Reports/Components/ReportBuilder'

    // ---------------- props / emits ----------------

    const props = defineProps<{
        viewModel: ReportBuilderViewModel
    }>()

    const emit = defineEmits<{
        (e: 'create-report', reportName: string | null): void
    }>()

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value?.opened ?? false)

    // ---------------- actions ----------------

    function onFormSubmit()
    {
        emit('create-report', vm.value.reportName)
    }

    function close()
    {
        vm.value.close()
    }
</script>


<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Create report</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form id="report-builder-form" @submit.prevent="onFormSubmit">
                            <div class="form-group">
                                <label>Name:</label>
                                <input v-model.trim="vm.reportName" type="text" class="form-control" required minlength="2" maxlength="100">
                                <small class="text-danger">{{vm.reportNameError}}</small>
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer justify-content-between">
                        <button type="submit" form="report-builder-form" class="btn btn-primary">Create</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>